import { ASSIGNED_USERS_ACTION_TYPE } from '../actions/assignedUsers.actions';

const initialState = [];

const assignedUsersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ASSIGNED_USERS_ACTION_TYPE.GET_ASSIGNED_TO_APPLICATION_USERS:
      return Array.isArray(payload) ? payload : state;

    case ASSIGNED_USERS_ACTION_TYPE.RESET_ASSIGNED_USERS_STATE:
      return initialState;

    default:
      return state;
  }
};

export default assignedUsersReducer;
